import React from "react";
import "./RichiediOmaggioCase.scss";
import {Redirect} from "react-router";
import Hero from "../../../common/Hero/Hero";
import {Row, Col, Container} from "react-bootstrap";
import {useTranslation, Trans} from "react-i18next";
import {CaseForms, RichiediOmaggioTipi} from "../../../../helpers/enums";
import ArrowLink from "../../../common/ArrowLink/ArrowLink";

import KitRubinettoImage from "./assets/rubinetto.jpg";
import TemporizzatoreDocciaImage from "./assets/timer.jpg";
import IngannaSciacquoneImage from "./assets/inganna-sciacquone.jpg";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";

const RichiediOmaggioMain = () => {
  const {t} = useTranslation();
  const richiedi_data = [
    {
      title: t("cases.richiedi_omaggio.omaggi.kit_rubinetto"),
      linkTo: "/richiedi-omaggio/kit-rubinetto",
      linkText: t("cases.richiedi_omaggio.omaggi.scopri"),
      icon: KitRubinettoImage,
    },
    {
      title: t("cases.richiedi_omaggio.omaggi.temporizzatore_doccia"),
      linkTo: "/richiedi-omaggio/temporizzatore-doccia",
      linkText: t("cases.richiedi_omaggio.omaggi.scopri"),
      icon: TemporizzatoreDocciaImage,
    },
    {
      title: t("cases.richiedi_omaggio.omaggi.inganna_sciacquone"),
      linkTo: "/richiedi-omaggio/sacchetto-inganna-sciacquone",
      linkText: t("cases.richiedi_omaggio.omaggi.scopri"),
      icon: IngannaSciacquoneImage,
    },
  ];

  return (
    <>
      <Hero
        backTo={"/dashboard"}
        backToText={t("common.back.home")}
        title={t("cases.richiedi_omaggio.title")}
        description={t("cases.richiedi_omaggio.description")}/>
      <div className={"container"}>
        <Row>
          <Col>
            <section
              className="RichiediOmaggioCardData"
              data-testid="RichiediOmaggioCardData"
            >
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="row card-container">
                      {richiedi_data.slice(0, 3).map((richiedi) => (
                        <div className="col-md-6 col-lg-4" key={richiedi.title}>
                          <div className="card">
                            <div
                              className="card-body d-flex flex-column justify-content-between align-items-center text-center">
                              <div className="card-icon">
                                <img src={richiedi.icon} alt=""/>
                              </div>
                              <h3 className="rectangle rectangle-30 rectangle-extreme-left title-card">
                                <span>{richiedi.title}</span>
                              </h3>
                              <ArrowLink to={richiedi.linkTo}>
                                {richiedi.linkText}
                              </ArrowLink>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </div>
    </>
  );
};

const RichiediOmaggioDettaglio = (props) => {
  const {t} = useTranslation();
  const {omaggio} = props;
  const mappingOmaggi = {
    "kit-rubinetto": RichiediOmaggioTipi.KIT_RUBINETTO,
    "temporizzatore-doccia": RichiediOmaggioTipi.TEMPORIZZATORE_DOCCIA,
    "sacchetto-inganna-sciacquone": RichiediOmaggioTipi.SACCHETTO_INGANNA_SCIACQUONE,
  };
  return (
    <>
      <Hero
        title={t("cases.richiedi_omaggio.title")}
        backTo={"/richiedi-omaggio"}
        backToText={t("richiedi_omaggio.back")}
      />
      <Container>
        <Row style={{marginBottom: 30}}>
          <Col xs={12} md={{span: 10, offset: 1}}>
            <h2 className="text-md-24 font-light">{<Trans i18nKey={
              "cases.richiedi_omaggio.omaggi." +
              omaggio.split("-").join("_") +
              ".spiegazione"}
            />}</h2>
          </Col>
        </Row>

        <CaseGenerator
          type={CaseForms.RichiediOmaggio}
          initialValues={{type: mappingOmaggi[omaggio]}}
        />
      </Container>
    </>
  );
};

const RichiediOmaggioCase = props => {
  const match = props.match || props.computedMatch;
  const {params} = match;
  const {omaggio} = params;

  const mappingOmaggi = {
    "kit-rubinetto": RichiediOmaggioTipi.KIT_RUBINETTO,
    "temporizzatore-doccia": RichiediOmaggioTipi.TEMPORIZZATORE_DOCCIA,
    "sacchetto-inganna-sciacquone": RichiediOmaggioTipi.SACCHETTO_INGANNA_SCIACQUONE,
  };
  if (omaggio && !mappingOmaggi[omaggio]) {
    return <Redirect to={"/richiedi-omaggio"}/>;
  }

  return (
    <div className="RichiediOmaggioCase" data-testid="RichiediOmaggioCase">
      {omaggio ? (
        <RichiediOmaggioDettaglio omaggio={omaggio}/>
      ) : (
        <RichiediOmaggioMain/>
      )}
    </div>
  );
};

RichiediOmaggioCase.propTypes = {};

export default RichiediOmaggioCase;
